import {JSX, memo} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonWithImage} from "@/shared/ui/buttons";
import {assetPath} from "@/shared/utils/asset-path";

interface VideoTestimonialsNavigationProps {
    currentIndex: number;
    totalVideos: number;
    hasNavigation: boolean;
    onPrev: () => void;
    onNext: () => void;
    onGoTo: (index: number) => void;
}

export const VideoTestimonialsNavigation = memo(function VideoTestimonialsNavigation({
    currentIndex,
    totalVideos,
    hasNavigation,
    onPrev,
    onNext,
    onGoTo,
}: VideoTestimonialsNavigationProps): JSX.Element {
    return (
        <div className="video-testimonials__navigation">
            <ButtonWithImage
                className="video-testimonials__navigation-button video-testimonials__navigation-button--prev"
                variant="primary"
                onClick={onPrev}
                aria-label="Previous video"
                disabled={!hasNavigation}
            >
                <SmartImage src={assetPath("/images/icons/navigation/arrow-left.svg")} alt="arrow" width={16} height={16} aria-hidden="true" />
            </ButtonWithImage>
            <div className="video-testimonials__pagination">
                {Array.from({length: totalVideos}, (_, index) => (
                    <button
                        key={index}
                        className={`video-testimonials__pagination-item ${index === currentIndex ? "video-testimonials__pagination-item--active" : ""}`}
                        onClick={() => onGoTo(index)}
                        aria-label={`Go to slide ${index + 1}`}
                        aria-current={index === currentIndex ? "true" : undefined}
                    />
                ))}
            </div>
            <ButtonWithImage
                className="video-testimonials__navigation-button video-testimonials__navigation-button--next"
                variant="primary"
                onClick={onNext}
                aria-label="Next video"
                disabled={!hasNavigation}
            >
                <SmartImage src={assetPath("/images/icons/navigation/arrow-right.svg")} alt="arrow" width={16} height={16} aria-hidden="true" />
            </ButtonWithImage>
        </div>
    );
});
